import { render, staticRenderFns } from "./ScreenContabilidad.vue?vue&type=template&id=190e39d6"
import script from "./ScreenContabilidad.vue?vue&type=script&lang=js"
export * from "./ScreenContabilidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports